if (!customElements.get('deep-sky-results')) {
  customElements.define('deep-sky-results', class extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('.ta-deep-sky-results__viewport');
      this.slides = Array.from(this.querySelectorAll('.ta-deep-sky-results__slide'));
      if (!this.slider || !this.slides.length) return;

      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateCaption();
        });
      };
      this.slider.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(this.onScroll);
      this.resizeObserver.observe(this.slider);
      this.setAttribute('data-ready', '');
      this.updateCaption();
    }

    disconnectedCallback() {
      this.slider?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    updateCaption() {
      const viewport = this.slider.getBoundingClientRect();
      const rtl = getComputedStyle(this.slider).direction === 'rtl';
      let activeIndex = 0;
      let nearestDistance = Infinity;

      this.slides.forEach((slide, index) => {
        const bounds = slide.getBoundingClientRect();
        const distance = Math.abs(rtl ? viewport.right - bounds.right : bounds.left - viewport.left);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          activeIndex = index;
        }
      });

      this.slides.forEach((slide, index) => {
        slide.querySelector('.ta-deep-sky-results__caption')?.setAttribute('aria-hidden', String(index !== activeIndex));
      });
    }
  });
}
